const ANIMATION_LIFECYCLE_EVENTS = {
	NAVIGATION_PHASE_CHANGED: 'animation_lifecycle_navigation_phase_changed',
}

const NAVIGATION_ANIMATION_PHASES = {
	IDLE: 'idle',
	OUT_STARTED: 'out-started',
	OUT_ENDED: 'out-ended',
	DOM_REPLACING: 'dom-replacing',
	IN_PREPARING: 'in-preparing',
	IN_STARTED: 'in-started',
	IN_ENDED: 'in-ended',
	STABLE: 'stable',
}

const OVERLAY_ANIMATION_PHASES = {
	HIDDEN: 'hidden',
	OPENING: 'opening',
	VISIBLE: 'visible',
	CLOSING: 'closing',
}

export { ANIMATION_LIFECYCLE_EVENTS, NAVIGATION_ANIMATION_PHASES, OVERLAY_ANIMATION_PHASES }
